import { Container, Typography } from "@mui/material";
import React from "react";
import { TestimonialCarousel } from "./Testimonials";
import ConsultationModal from "../Header/ConsultationModal";

export default function TestimonialCarouselView({requestSubmitted, setRequestSubmitted}) {
  
  return (
    <Container id="testimonials" sx={{ padding: "20px 0px" }}>
      <Typography variant="h2" sx={{ padding: "20px 0px" }}>
        Hear from some of Edward Russell's previous clients
      </Typography>
      <TestimonialCarousel />
      <Container
        sx={{
          padding: "20px 0px",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <ConsultationModal
          requestSubmitted={requestSubmitted}
          setRequestSubmitted={setRequestSubmitted}
        />
      </Container>
    </Container>
  );
}
